import { Suspense } from "react";
import "./App.css";
import { RouterProvider } from "react-router-dom";
import routes from "./routes";
import { Spin } from "antd";

function App() {
  return (
    <Suspense fallback={<Spin size="large" className="global-spin" />}>
      <RouterProvider router={routes} />
    </Suspense>
  );
}

export default App;
